import Phaser from "phaser";
import UiInterface from "./UiInterface";
import ProgressBar from "./ProgressBar";
import Tracking from "./Tracking";
import MainScene from "./MainScene";
import DetailedStatsPanel from "./DetailedStatsPanel";
import Pqp from "../../3x1010/Pqp";
import Locale from "../../3x1010/Locale";
export default class ZoomPanel extends Phaser.GameObjects.Container {
  constructor(scene, stroke, ct, strokeNumber, callback) {
    super(scene);
    this.scene = scene;
    this.stroke = stroke;
    this.fasi = this.stroke.fasi;
    this.ct = ct;
    this.strokeNumber = strokeNumber;
    this.currentRatio = ZoomPanel.RATIO;
    this.callback = callback;
  }

  init() {
    // Dal colpo ricava la fase
    // Calcola il numero di fotogrammi
    this.totaleFrames = this.fasi[this.fasi.length - 1].frameTime - this.fasi[0].frameTime;
    this.startFrame = this.fasi[0].frameTime;
    this.endFrame = this.fasi[this.fasi.length - 1].frameTime;
    // Crea un contenitore dei dati
    this.createData();

    // Crea lo sfondo
    this.panel.x = ZoomPanel.PADDING / 2;

    this.width = this.panel.width + ZoomPanel.PADDING;
    this.height = this.panel.height + ZoomPanel.PADDING + 40;

    this.panel.y = this.panel.height + 40;

    this.createBackground();

    // Crea il titolo
    let posy = 0;
    const title = this.scene.add.text(0, 0, Locale.g("detailC", null, this.strokeNumber), { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_1) });
    title.setOrigin(0, 0);
    this.add(title);
    title.y = ZoomPanel.PADDING / 2;
    title.x = ZoomPanel.PADDING / 2;
    posy += 32;
    this.title = title;

    // Aggiunge una x immagine per chiudere nell'angolo
    const close = this.scene.add.image(this.width - 16, 16, "close");
    close.setInteractive({ useHandCursor: true });
    this.add(close);
    close.on("pointerdown", (e) => {
      this.alpha = 0.00001;
      if (this.additionalInfo) {
        this.additionalInfo.destroy();
        this.additionalInfo = null;
      }
      this.scene.time.delayedCall(300, () => {
        this.ct.zoomPanelShown = false;
        this.ct.closeZoomPanel();
      });
    });

    // Ci riaggiunge il contenitore
    this.bringToTop(this.panel);
    this.setInteractive({ hitArea: new Phaser.Geom.Rectangle(this.width / 2, this.height / 2, this.width, this.height), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: false });
  }

  createBackground() {
    const graphics = this.scene.add.graphics();
    graphics.fillGradientStyle(0x152ba0, 0x152ba0, 0x152ba0, 0x152ba0, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL, Tracking.ALPHA_PANEL);
    graphics.fillRect(0, 0, this.width, this.height);
    this.add(graphics);
  }

  createData() {
    this.panel = this.scene.add.container(0, 0);
    this.add(this.panel);
    // ricostrusce quella parte di timeline
    //console.log(this.stroke);
    //console.log(this.fasi);
    // Linea orizzontale lunga quando il totalframes
    let widthBar = this.totaleFrames * this.currentRatio;
    //console.log("...........");
    //console.log(widthBar);
    while (widthBar > Tracking.WIDTH - 32 - 160 - 32) {
      this.currentRatio -= 1;
      widthBar = this.totaleFrames * this.currentRatio;
    }
    //console.log(widthBar);

    const hbar = this.scene.add.rectangle(0, 0, widthBar, UiInterface.BAR_THICKNESS, ProgressBar.COLOR_1);
    hbar.setOrigin(0, 0);
    this.panel.add(hbar);

    // Linea orizzontale lunga quando il totalframes che mostra dove si sta spostqndo il mouse (lower)
    const hbarMouseDown = this.scene.add.rectangle(0, 0, widthBar, UiInterface.BAR_THICKNESS, ProgressBar.COLOR_2);
    hbarMouseDown.setOrigin(0, 0);
    this.panel.add(hbarMouseDown);
    this.mouseBarDown = hbarMouseDown;
    this.mouseBarDown.visible = false;

    // Linea orizzontale lunga quando il totalframes che mostra dove si è
    const hbarPos = this.scene.add.rectangle(0, 0, widthBar, UiInterface.BAR_THICKNESS, ProgressBar.COLOR_FRONT);
    hbarPos.setOrigin(0, 0);
    this.panel.add(hbarPos);
    this.posBar = hbarPos;
    this.posBar.visible = false;

    // Linea orizzontale lunga quando il totalframes che mostra dove si sta spostqndo il mouse (upper)
    const hbarMouseUp = this.scene.add.rectangle(0, 0, widthBar, UiInterface.BAR_THICKNESS, ProgressBar.COLOR_2);
    hbarMouseUp.setOrigin(0, 0);
    this.panel.add(hbarMouseUp);
    this.mouseBarUp = hbarMouseUp;
    this.mouseBarUp.visible = false;

    // Crea sulla line verticale un rettangolo per beccare i click, il rettangolo è in super alpha
    const clickbar = this.scene.add.rectangle(0, 0, widthBar, ZoomPanel.VBAR_HEIGHT, ProgressBar.COLOR_1);
    clickbar.setOrigin(0, 0);
    clickbar.setAlpha(0.00001);
    clickbar.setInteractive({ hitArea: new Phaser.Geom.Rectangle(0, 0, widthBar, ZoomPanel.VBAR_HEIGHT), useHandCursor: true });
    this.panel.add(clickbar);
    clickbar.y = -ZoomPanel.VBAR_HEIGHT / 2;
    clickbar.on("pointerdown", (e) => {
      // Calcola il fotogramma
      /*console.log(e.x);
      console.log(this.x);
      console.log(this.panel.x);*/
      const delta = (Tracking.WIDTH - UiInterface.PROGRESS_BAR_WIDTH) / 2 + 16;
      const x = e.x - this.x - delta + ZoomPanel.PADDING / 4;
      //console.log(x);
      const frame = Math.floor(x / this.currentRatio) + this.startFrame;
      // Converte il frame in tempo
      const time = frame / MainScene.FPS;
      this.ct.gotoTime(time);
      this.mouseBarDown.visible = false;
      this.mouseBarUp.visible = false;
    });

    clickbar.on("pointermove", this.onMove.bind(this));

    clickbar.on("pointerout", (e) => {
      this.mouseBarDown.visible = false;
      this.mouseBarUp.visible = false;
      this.dispatch(ProgressBar.EVENT_HIDE_TIME_TO_SEEK_TO);
    });

    // Linea verticale per ogni fase
    for (let x = 0; x < this.fasi.length; x++) {
      const fase = this.fasi[x];
      const xbar = (fase.frameTime - this.startFrame) * this.currentRatio;
      const vbar = this.scene.add.rectangle(xbar, 0, UiInterface.BAR_THICKNESS, ZoomPanel.VBAR_HEIGHT, ProgressBar.COLOR_1);
      vbar.setOrigin(0, 0);
      vbar.y = -(ZoomPanel.VBAR_HEIGHT / 2);
      this.panel.add(vbar);
    }

    // Pallino tra una fase e l'altra
    for (let x = 0; x < this.fasi.length - 1; x++) {
      const fase = this.fasi[x];
      const nextFase = this.fasi[x + 1];
      // a metà tra una fase e l'altra
      const diff = nextFase.frameTime - fase.frameTime;
      const xbar = (fase.frameTime - this.startFrame + diff / 2) * this.currentRatio;
      //const xbar =
      //
      let color = ProgressBar.NO_ERROR_COLOR;
      let index = Math.floor(fase.erroriTotali / ProgressBar.ERROR_COLOR_INTERVAL);
      if (index >= ProgressBar.ERROR_COLORS.length) {
        index = ProgressBar.ERROR_COLORS.length - 1;
      }
      color = ProgressBar.ERROR_COLORS[index];
      if (fase.erroriTotali === 0) {
        color = ProgressBar.NO_ERROR_COLOR;
      }

      if (fase.noData) {
        color = ProgressBar.NO_DATA_COLOR;
      }

      const vbar = this.scene.add.circle(xbar, 0, ZoomPanel.RADIUS, color);
      vbar.setInteractive({ hitArea: new Phaser.Geom.Circle(0, 0, ZoomPanel.RADIUS * 2), useHandCursor: true });
      //vbar.setOrigin(0, 0);
      vbar.y = -ZoomPanel.VBAR_HEIGHT * 1.5;
      vbar.x += UiInterface.BAR_THICKNESS / 2;
      this.panel.add(vbar);
      // Sopra ogni pallino scrive il nome della fase
      let lbl = Locale.g(fase.label) + " (" + fase.erroriTotali + ")";

      //let lbl = fase.label + " (" + fase.erroriTotali + ")";
      if (fase.noData) {
        lbl = Locale.g(fase.label);
      }
      if (fase.erroriTotali === 0) {
        lbl = Locale.g(fase.label);
      }

      console.log("lbl", lbl);
      const txt = this.scene.add.text(xbar, 0, lbl, { fontFamily: "DIN Next LT Pro", fontSize: "32px", color: this.toHexColor(ProgressBar.COLOR_1) });
      txt.setOrigin(0.5, 0);
      //txt.setStroke(Tracking.STROKE_COLOR, Tracking.STROKE_INTENSITY);
      txt.y = -ZoomPanel.VBAR_HEIGHT * 4.1;
      if (x === 0) {
        txt.setOrigin(0, 0);
        txt.x = 0;
      }
      this.panel.add(txt);
      txt.visible = false;
      vbar.on("pointerover", () => {
        txt.visible = true;
      });
      vbar.on("pointerout", () => {
        txt.visible = false;
      });

      vbar.on("pointerdown", (e) => {
        // Prende il frame della fase
        const o = fase.stats;
        //let min = 1000000000;
        let min = fase.frameTime;
        /*debugger;
        let lFound = false;
        for (let prop in o) {
          if (typeof o[prop] !== "string") {
            if (o[prop]) {
              const el = o[prop];
              if (el.frame_start < min) {
                min = el.frame_start;
                lFound = true;
              }
            }
          }
        }
        if (lFound) {*/
        this.ct.gotoTime(min / MainScene.FPS);
        //}

        this.showAdditionalInfo(fase);
      });
    }

    this.panel.width = widthBar;
    this.panel.height = 100;
  }

  onMove(e) {
    this.mouseBarDown.visible = false;
    this.mouseBarUp.visible = false;
    const delta = (Tracking.WIDTH - UiInterface.PROGRESS_BAR_WIDTH) / 2 + 16;
    const x = e.x - this.x - delta + ZoomPanel.PADDING / 4;
    const frame = Math.floor(x / this.currentRatio) + this.startFrame;

    this.mouseBarDown.width = (frame - this.startFrame) * this.currentRatio;
    this.mouseBarUp.width = (frame - this.startFrame) * this.currentRatio;
    if (this.mouseBarDown.width > this.posBar.width) {
      this.mouseBarDown.visible = true;
    } else {
      this.mouseBarUp.visible = true;
    }

    const totalDuration = MainScene.that.vid.getDuration();
    const time = frame / MainScene.FPS;
    const perc = time / totalDuration;

    this.dispatch(ProgressBar.EVENT_SHOW_TIME_TO_SEEK_TO, perc);
  }

  toHexColor(num) {
    let s = num.toString(16);
    while (s.length < 6) {
      s = "0" + s;
    }
    return "#" + s;
  }

  showAdditionalInfo(fase) {
    if (this.additionalInfo) {
      this.additionalInfo.destroy();
      this.additionalInfo = null;
    }
    //console.log(fase);
    this.additionalInfo = new DetailedStatsPanel(this.scene, fase, this.stroke, this);
    this.additionalInfo.init();
    this.additionalInfo.x = 16;
    this.additionalInfo.y = 16;
    //this.add(this.additionalInfo);
    this.scene.add.existing(this.additionalInfo);
    this.additionalInfo.setBar(this.additionalInfo.frame_start);
  }

  dispose() {
    if (this.additionalInfo) {
      this.additionalInfo.destroy();
      this.additionalInfo = null;
    }
    this.destroy();
  }

  setBar(percentRespectTotaltime) {
    this.posBar.visible = true;
    const duration = MainScene.that.vid.getDuration();
    const time = duration * percentRespectTotaltime;
    const frame = Math.round(time * MainScene.FPS);
    //    console.log(frame);
    //  console.log(this.startFrame, this.endFrame);
    if (frame < this.startFrame) {
      this.posBar.visible = false;
      return;
    }
    if (frame > this.endFrame) {
      this.posBar.visible = true;
      this.posBar.width = this.totaleFrames * this.currentRatio;
      this.dispatch(ProgressBar.EVENT_PAUSE);
      const time = this.startFrame / MainScene.FPS;
      this.ct.gotoTime(time);
      this.mouseBarDown.visible = false;
      this.mouseBarUp.visible = false;

      return;
    }
    this.posBar.width = (frame - this.startFrame) * this.currentRatio;

    if (this.additionalInfo) {
      if (frame >= this.additionalInfo.frame_start && frame < this.additionalInfo.frame_end) {
        this.additionalInfo.setBar(frame);
      } else {
        const fase = this.getCurrentFase(frame);
        this.currentFase = fase;
        if (fase) {
          this.showAdditionalInfo(fase);
          this.additionalInfo.setBar(frame);
        }
        //UiInterface.that.txtPhase.text = fase.label.toUpperCase();
        //console.log(fase.label.toUpperCase());1
      }
    }
  }

  updateGlobalFaseLabel() {
    //const frame = Math.round(ControlBar.that.currentTime * Tool.fps);

    if (this.currentFase) {
      //UiInterface.that.txtPhase.text = fase.label.toUpperCase();
      //console.log(this.currentFase.label.toUpperCase());
      UiInterface.that.txtPhase.setText(this.currentFase.label.toUpperCase());
    }
  }

  getCurrentFase(frame) {
    //console.log(frame);
    //console.log(this.fasi);
    for (let x = this.fasi.length - 1; x >= 0; x--) {
      const fase = this.fasi[x];
      if (frame >= fase.frameTime) {
        return fase;
      }
    }
    return null;
  }

  dispatch(type, data) {
    if (this.callback) {
      const e = { type };
      if (!Pqp.isNullOrEmpty(data)) {
        e.data = data;
      }
      this.callback.call(null, e);
    }
  }
}

ZoomPanel.RATIO = 12;
ZoomPanel.VBAR_HEIGHT = 20;
ZoomPanel.PADDING = 32;
ZoomPanel.RADIUS = 8;
